"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const forEach_1 = __importDefault(require("lodash/forEach"));
const keys_1 = __importDefault(require("lodash/keys"));
const includes_1 = __importDefault(require("lodash/includes"));
const prop_types_1 = __importDefault(require("prop-types"));
const sanitize_html_1 = __importDefault(require("sanitize-html"));
const react_1 = __importDefault(require("react"));
const marked_1 = require("marked");
const config_1 = require("./config");
const ProcessMarkdown_1 = require("./ProcessMarkdown");
const Markdown = ({ className, source, headingsStartFrom, rendererMethods, whitelist, inline, children, 'data-testid': testId, }) => {
    const markdown = (0, ProcessMarkdown_1.processMarkdown)({
        source,
        headingsStartFrom,
        rendererMethods,
        whitelist,
        inline,
    });
    if (!markdown)
        return null;
    if (children) {
        return children(markdown);
    }
    if (inline) {
        return (react_1.default.createElement("span", { className: `zedoc-react-markdown ${className}`, "data-testid": testId, 
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML: {
                __html: markdown,
            } }));
    }
    return (react_1.default.createElement("div", { className: `zedoc-react-markdown ${className}`, "data-testid": testId, 
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: markdown,
        } }));
};
Markdown.propTypes = {
    className: prop_types_1.default.string,
    source: prop_types_1.default.string,
    headingsStartFrom: prop_types_1.default.number,
    rendererMethods: prop_types_1.default.objectOf(prop_types_1.default.func),
    whitelist: prop_types_1.default.arrayOf(prop_types_1.default.string),
    inline: prop_types_1.default.bool,
    children: prop_types_1.default.func,
    'data-testid': prop_types_1.default.string,
};
Markdown.defaultProps = {
    className: '',
    source: '',
    headingsStartFrom: 0,
    rendererMethods: {},
    whitelist: [],
    inline: false,
    children: null,
    'data-testid': null,
};
exports.default = Markdown;
//# sourceMappingURL=Markdown.js.map